import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getHistoryRO(params) {
	return client.get("binary/repeat-order/history", {
		params: params,
	});
}

function getHistoryROSponsor(params) {
	return client.get("binary/repeat-order/history-sponsor", {
		params: params,
	});
}

function getPersonalOmset(params) {
	return client.get("binary/repeat-order/omset-personal", {
		params: params,
	});
}

function getGroupOmset(params) {
	return client.get("binary/repeat-order/omset-group", {
		params: params,
	});
}

function getDetailGroupOmset(params) {
	return client.get("binary/repeat-order/detail-omset-group", {
		params: params,
	});
}

function inputRO(params) {
	return client.post("binary/repeat-order", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function inputUpgrade(params) {
	return client.post("binary/upgrade", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getHistoryRO,
	getHistoryROSponsor,
	getPersonalOmset,
	getGroupOmset,
	getDetailGroupOmset,
	inputRO,
	inputUpgrade
};